declare global {
    interface Window {
      hj: any;
      _hjSettings: {
        hjid: number;
        hjsv: number;
      };
    }
  }
  
  /**
   * Initialize Hotjar with the provided site ID
   * @param hjid - Hotjar Site ID
   */
  export const initHotjar = (hjid: number): void => {
    if (typeof window !== 'undefined') {
      (function(h: any, o: any, t: any, j: any, a?: any, r?: any) {
        h.hj = h.hj || function() {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
        h._hjSettings = { hjid, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
  };
  
  /**
   * Track page views in Hotjar
   * @param pathname - Current page path
   */
  export const trackHotjarPageView = (pathname: string): void => {
    if (typeof window !== 'undefined' && window.hj) {
      window.hj('stateChange', pathname);
    }
  };